import { render, staticRenderFns } from "./ReceiptsView.html?vue&type=template&id=1f7dd384&"
import script from "./ReceiptsView.vue?vue&type=script&lang=ts&"
export * from "./ReceiptsView.vue?vue&type=script&lang=ts&"
import style0 from "./ReceiptsView.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports